import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { format } from "date-fns";

const PVInvoiceReport = ({ filter, groupName }: { filter: any, groupName: string | null }) => {
  const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>; loading: boolean });
  const dt = useRef<any>(null);
  const toast = useRef<any>(null);

  const header = (
    <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
      <h5 className="m-0">Prime Vendor Invoice Report</h5>
    </div>
  );
  const loadTableData = async () => {
    setTableData({ tableData: tableData.tableData, loading: true });

    const mappedFilter = {
      FromDate: filter?.fromDate,
      ToDate: filter?.ToDate,
      Company_ID: filter?.company_ID ?? null,
      Group_ID: filter?.company_Group_ID ?? null,
    };

    const response = await Fetch("Report_Timesheet/getPVInvoiceAddedCount", "GET", null, `filter=${JSON.stringify(mappedFilter)}`, null);
    if (response) {
      const data: Array<any> = await response.json();
      setTableData({ tableData: data, loading: false });
    }
  };

  useEffect(() => {
    loadTableData();
  }, [filter]);

  const isGroupWise = filter?.company_Type === "Company Group Wise";

  return (
    <>
      <DataTable
        style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px" }}
        resizableColumns
        showGridlines
        columnResizeMode="expand"
        exportFilename={format(new Date(), "dd-MM-yyyy hh_mm_ss a").toUpperCase()}
        ref={dt}
        size="small"
        stripedRows
        scrollable
        scrollHeight="70vh"
        value={tableData.tableData}
        header={header}
        loading={tableData.loading}
      >
        <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
        {isGroupWise ? <Column field="company_Name" header={`Company Name of ${groupName || ""}`} /> : <Column field="company_Name" header="Company" />}
        <Column field="total_PO" header="No of PO" footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.total_PO || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />
        <Column field="weekly" header="No of PO Weekly" footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.weekly || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />
        <Column field="bi_Weekly" header="No of PO BI Weekly" headerStyle={{ whiteSpace: "normal", minWidth: "100px" }} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.bi_Weekly || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />
        <Column field="four_Weekly" header="No of PO Four Weekly" headerStyle={{ whiteSpace: "normal", minWidth: "100px" }} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.four_Weekly || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />
        <Column field="semi_Monthly" header="No of PO Semi Monthly" headerStyle={{ whiteSpace: "normal", minWidth: "100px" }} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.semi_Monthly || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />
        <Column field="monthly" header="No of PO  Monthly" footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.monthly || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />
        <Column field="custom" header="No of  Custom" footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.custom || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />
        <Column field="totalInvoiceLeft" header="No of Pending PV Invoice" headerStyle={{ whiteSpace: "normal", minWidth: "100px" }} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.totalInvoiceLeft || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />
        <Column field="totalInvoiceAdded" header="No of Uploaded PV Invoice" headerStyle={{ whiteSpace: "normal", minWidth: "100px" }} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.totalInvoiceAdded || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />
      </DataTable>
      <Toast ref={toast} />
    </>
  );
};

export default PVInvoiceReport;
